import React from 'react';
import { Title, Link, Image } from '@landing/ui';

import * as styles from './Slide.module.scss';

export default function Slide({ image, title, description, link }) {
  return (
    <Link href={link} className={styles.slide}>
      <div className={styles.pictureWrapper}>
        <Image className={styles.picture} classImage={styles.img} src={image} alt={image.alt} />
      </div>
      <div className={styles.text}>
        <Title size="h4" color="white">
          {title}
        </Title>
        <p className={styles.subtitle}>{description}</p>
      </div>
    </Link>
  );
}
